import { IConfig } from '@cian/config/shared';

import { ICoordinates } from '../../../types';

interface IParams {
  config: IConfig;
  coordinates?: ICoordinates;
  id: number;
}

export const getMapPreviewUrl = ({ config, coordinates, id }: IParams) => {
  const mapPreviewTemplate = config.get<string>('audience.mapPreviewTemplate');

  if (!coordinates || !mapPreviewTemplate) {
    return '';
  }

  const params: Record<string, number> = { ...coordinates, id };

  return mapPreviewTemplate.replace(/{{(lat|lng|id)}}/g, (_, matched) => `${params[matched]}`);
};
